module.exports = __webpack_public_path__ + "static/img/marvelmatch.cc34f75.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/marvelmatch.png
// module id = 942
// module chunks = 2 8